/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserQuestionStatusSendOrderOneOf1
 */
export interface UserQuestionStatusSendOrderOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof UserQuestionStatusSendOrderOneOf1
     */
    status: UserQuestionStatusSendOrderOneOf1StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UserQuestionStatusSendOrderOneOf1
     */
    sentDateTime: string;
}


/**
 * @export
 */
export const UserQuestionStatusSendOrderOneOf1StatusEnum = {
    Sent: 'SENT'
} as const;
export type UserQuestionStatusSendOrderOneOf1StatusEnum = typeof UserQuestionStatusSendOrderOneOf1StatusEnum[keyof typeof UserQuestionStatusSendOrderOneOf1StatusEnum];


/**
 * Check if a given object implements the UserQuestionStatusSendOrderOneOf1 interface.
 */
export function instanceOfUserQuestionStatusSendOrderOneOf1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "sentDateTime" in value;

    return isInstance;
}

export function UserQuestionStatusSendOrderOneOf1FromJSON(json: any): UserQuestionStatusSendOrderOneOf1 {
    return UserQuestionStatusSendOrderOneOf1FromJSONTyped(json, false);
}

export function UserQuestionStatusSendOrderOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): UserQuestionStatusSendOrderOneOf1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'sentDateTime': json['sentDateTime'],
    };
}

export function UserQuestionStatusSendOrderOneOf1ToJSON(value?: UserQuestionStatusSendOrderOneOf1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'sentDateTime': value.sentDateTime,
    };
}

